<template>
	<div>
		<div><h1 hidden=false>{{siteIdF}}</h1> </div>
		<el-form :inline="true" :model="formData" class="demo-form-inline" ref='hisForm'>
		   <el-form-item label="时间">
		      <el-date-picker type="datetime" placeholder="起始时间" v-model="formData.startTime"></el-date-picker>-
		        <el-date-picker type="datetime" placeholder="结束时间" v-model="formData.endTime"></el-date-picker>
		    </el-form-item>
		  <el-form-item>
			<el-button type="primary" @click="onSubmit">查询</el-button>
		  </el-form-item>
		  <el-form-item>
		     <download-excel
		         class = "export-excel-wrapper"
				 :data="json_data"
		         :fields = "json_fields"
				 
				 :name="filename"
		         >
		        
		         <el-button type="primary" >导出EXCEL</el-button>
		     </download-excel>
			 
		  </el-form-item>
		  
		</el-form>
		<el-table :header-cell-style="{background:'#eee',color:'#606266'}"
		    :data="tableData"
		   v-show="play"
		   size="small"
			:row-class-name="tableRowClassName"
		    style="width: 100%">
			<el-table-column 
			  prop="id"
			  sortable
			  label="ID"
			  
			  width="70">
			  
			</el-table-column>
			<el-table-column
			  prop="time"
			  sortable
			  label="time"
			  
			  width="180">
			  
			</el-table-column>
			
		    <el-table-column v-for="(item,key) in field" :key="key"
		      :prop="item"
			  sortable
		      :label="item"
			  v-if="item.mingCh!='time' && item.mingCh !='ID'"
		      width="160">
			  
		    </el-table-column>
		    
		  </el-table>
		   <div class="block" v-show="play">
		     
		      <el-pagination
		        @size-change="handleSizeChange"
		        @current-change="handleCurrentChange"
				v-show="play"
		        :current-page="currentPage"
		        :page-sizes="[10, 20, 30, 40]"
		        :page-size="pageSize"
		        layout="total, sizes, prev, pager, next, jumper"
		        :total="totalD">
		      </el-pagination>
		    </div>
	</div>
</template>

<script>
	import JsonExcel from 'vue-json-excel'
	export default {
		name: "DayRecord",
		mounted() {
			//debugger
			//this.updata(this.$store.state.siteId);
		},
		data() {
			return {
			  pageSize:10,
			  totalD: 0,
			  currentPage:1 ,
			  formData: {				
				startTime:null,
				endTime:null,
				start:'',
				limit:'',
				siteId:null
			  },
			  tableData:[],
			  field:[],
			  play:false,
			  filename:null,
			  json_fields: {},
			  json_data: [],
				json_meta: [
				  [
					{
					  " key ": " charset ",
					  " value ": " utf- 8 "
					}
				  ]
				],
			siteId:0
			}
		  },
		computed:{
			siteIdF: {
				get:function(){
					//debugger
					//console.log("hachlog:"+this.$store.state.siteId);
					//this.$data.siteId=this.$store.state.siteId;
					this.updata(this.$store.state.siteId);
					
					return this.$store.state.siteId;
				},
				set:function(){
					debugger
					this.$data.siteId=this.$store.state.siteId;
					//this.msg = value; //最后修改了msg    
				}
			 },
		},
		methods:{
			
			startDownload(){
				alert('show loading');
			},
			finishDownload(){
				alert('hide loading');
			},
			handleSizeChange(val) {
				
				console.log(`每页 ${val} 条`);
				this.$data.pageSize=val;
				this.initEmps();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				
				this.$data.currentPage=val;
				this.initEmps();
			},
			initEmps(){
				debugger
				console.log(this.$data.currentPage+":"+this.$data.pageSize); 
				this.$data.formData.limit=this.$data.pageSize;
				this.$data.formData.start=(this.$data.currentPage-1)*this.$data.pageSize;
				//that=this;
				/* if(this.$data.formData.endTime!=null){
					var et=this.$data.formData.endTime+"";
					this.$data.formData.endTime=et.substr(0,et.indexOf(" GMT"));
				}
				if(this.$data.formData.endTime!=null){
					et=this.$data.formData.startTime+"";
					this.$data.formData.startTime=et.substr(0,et.indexOf(" GMT"));
				} */
				this.postRequest('/data/real/dataRecord',this.$data.formData).then(resp => {
					if(resp.error){
						this.$data.totalD=null;
						this.$data.field=null;
						 this.$data.tableData=null;
						 this.$data.play=false;
						 this.$data.json_fields=null;
						 this.$data.json_data=null;
						this.$message({
						  type:'info',//info
						  message: resp.error
						}); 
					}else{
						this.$data.totalD=resp["totalD"];
						this.$data.field=resp["field"];
						 this.$data.tableData=resp["data"];
						 this.$data.play=true;
					}
					
					 
					/* console.log(this.$data.tableData); */
					
				});
				if(this.$data.play||this.$data.formData.startTime==null)
				this.fetchData();
			},
			reqPostData(){
				
				
				console.log("endTime:"+this.formData.endTime+"---startTime:"+this.formData.startTime);
				
				this.initEmps();
				
			},
		  onSubmit() {
					  this.reqPostData(); 
			/* console.log(this.form.endTime); */
		  },
			
			 fetchData() {
				this.$data.formData.limit=null;
				this.$data.formData.start=null;
				var jsd=[];
				
				/* console.log("endTime:"+this.formData.endTime+"---startTime:"+this.formData.startTime); */
				this.postRequest('/data/real/dataRecord',this.$data.formData).then(resp => {
					var jsonf={"time":"time"};
					for(var k in resp["field"]){
						var st=resp["field"][k];
						jsonf[st]=st;
						
					}
					
					
					this.$data.json_fields=jsonf;
					this.$data.json_data=resp["data"];
					
					
				})
				var md = new Date();
				this.$data.filename=this.$store.state.siteName+"日志"+this.formatLongDate(md)+".xls";
			},
			formatLongDate (date) {
				let myyear = date.getFullYear();
				let mymonth = date.getMonth() + 1;
				let myweekday = date.getDate();
				let myHour = date.getHours();
				let myMin = date.getMinutes();
				let mySec = date.getSeconds();

				if (mymonth < 10) {
					mymonth = '0' + mymonth;
				}
				if (myweekday < 10) {
					myweekday = '0' + myweekday;
				}
				if (myHour < 10) {
					myHour = '0' + myHour;
				}
				if (myMin < 10) {
					myMin = '0' + myMin;
				}
				if (mySec < 10) {
					mySec = '0' + mySec;
				}
				return (myyear + '' + mymonth + '' + myweekday + '' + myHour + '' + myMin + '' + mySec);
			},
			
			tableRowClassName({row, rowIndex}) {
					if ((rowIndex%2) == 1) {
					  return 'success-row';
					} 
					return '';
			},
			
			updata(id){
				if(this.$data.siteId!=id){
					this.$data.siteId=id;
					this.$data.formData.siteId=id;
					this.initEmps();
				}
				
			}
		}
	}
</script>

<style>
	.el-table .success-row {
	    background: #f0f9eb;
	  }
	.block{
		margin-top: 10px;
	}
</style>
